function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-33.3%",
  y: "-33.3%",
  width: "166.7%",
  height: "166.7%",
  filterUnits: "objectBoundingBox",
  id: "a"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.133647531 0 0 0 0 0.61798048 0 0 0 0 0.545453191 0 0 0 0.1 0",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("circle", {
  id: "b",
  cx: 54,
  cy: 54,
  r: 54
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.34,
  transform: "translate(24 24)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#a)",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#E3EFE8",
  xlinkHref: "#b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M33.91 34h88v88h-88z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.413 111.17c-.017 1.713 1.427 3.151 3.18 3.165 1.686.012 3.149-1.394 3.19-3.067.043-1.678-1.35-3.08-3.088-3.11-1.838-.03-3.265 1.278-3.282 3.012zM79.19 39.5c1.663.532 2.814 1.703 3.996 2.879 3.124 3.101 6.301 6.152 9.46 9.219a35317.47 35317.47 0 0 0 19.314 18.74c1.608 1.557 2.127 3.383 1.332 5.448-.81 2.106-2.467 3.169-4.785 3.291-1.636.087-2.553.917-2.749 2.48-.043.348-.035.703-.035 1.055-.002 8.175 0 16.35-.002 24.526 0 3.239-2.093 5.304-5.433 5.315-2.952.01-5.907.048-8.855-.063-7.268-.274-13.842-5.75-15.201-12.632a22.219 22.219 0 0 1-.39-3.907c-.055-3.206-.018-6.412-.018-9.618v-1.082c-3.689-.303-7.07-1.32-9.879-3.532-2.176-1.714-4.2-3.637-6.105-5.633-1.447-1.516-1.552-3.44-.666-5.31.872-1.843 2.409-2.84 4.528-2.948.29-.014.58-.036.941-.06v-2.112h2.498v7.099h-2.457v-2.32c-1.558-.224-2.542.199-3.124 1.272-.584 1.078-.402 2.198.58 3.157 1.399 1.367 2.768 2.772 4.257 4.045 6.34 5.423 16.065 5.157 22.126-.566 1.116-1.052 2.21-2.128 3.31-3.195 1.17-1.133 1.46-2.236.888-3.354-.603-1.179-1.541-1.583-3.382-1.39v2.34h-2.508v-7.083h2.46v2.168c.497 0 .884-.018 1.268.003 2.024.11 3.54 1.027 4.434 2.782.903 1.772.973 3.69-.362 5.173-2.844 3.163-5.744 6.37-9.934 7.95-1.98.748-4.09 1.173-6.308 1.79v1.853c0 3.014-.002 6.027.001 9.04.007 7.483 6.27 13.589 14 13.639 2.622.017 5.244.01 7.864 0 1.786-.006 2.752-.855 2.944-2.575.038-.349.028-.704.028-1.056.001-8.176-.002-16.35.002-24.526.002-3.015 1.914-4.966 5.049-5.174 1.223-.082 2.16-.576 2.612-1.738.445-1.143.022-2.05-.816-2.86-2.225-2.157-4.435-4.328-6.66-6.486A64307.573 64307.573 0 0 0 80.302 43.13c-1.655-1.604-2.919-1.597-4.59.017-9.924 9.59-19.846 19.181-29.776 28.764-.798.77-1.322 1.592-1.016 2.731.312 1.162 1.241 1.874 2.617 1.985 3.275.265 5.152 2.224 5.155 5.418.006 8.303.002 16.606.002 24.91 0 2.093.922 3 3.06 3.006 1.161.004 2.326-.052 3.483.02.75.045 1.09-.196 1.38-.87.88-2.047 3.145-3.36 5.305-3.183 2.424.199 4.321 1.716 4.941 3.953.727 2.618-.745 5.36-3.38 6.295-2.628.933-5.652-.203-6.767-2.688-.394-.877-.864-1.09-1.767-1.05a36.932 36.932 0 0 1-4.176-.04c-2.646-.178-4.64-2.295-4.641-4.868-.008-8.4-.002-16.8-.004-25.2 0-2.223-.77-3.04-3.069-3.26-2.415-.231-4.175-1.748-4.697-4.036-.041-.18-.133-.349-.2-.523v-.962c.328-1.76 1.511-2.967 2.768-4.176 9.415-9.06 18.806-18.142 28.191-27.231 1.098-1.063 2.169-2.132 3.681-2.642h2.39z",
  stroke: "#2B9D8B",
  strokeWidth: 0.75,
  fill: "#2B9D8B"
}));

function SvgTransparentLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentLogo);
export default __webpack_public_path__ + "static/media/transparent_logo.1c10368c.svg";
export { ForwardRef as ReactComponent };